import React from 'react'
import SettingApiForm from '../components/setting/SettingsIpForm'

const SettingsIp = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingsIp